/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'

import baseurl from '../../../@core/auth/jwt/baseurl'
import emiter from '../../../utility/hooks/emiiter'

const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 2000
    }
  )
}

const showSuccessMsg = (msg) => {
  toast.success(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Success</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 2000
    }
  )
}

export const getData = createAsyncThunk(
  'appServiceItem/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/service-item', {
      params
    })
    return {
      params,
      data: response.data.items,
      total: response.data.totalCount
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const getById = createAsyncThunk(
  'appServiceItem/getById',
  async (id) => {
    try {
      const response = await baseurl.get(`/api/app/service-item/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (response.status === 200) {
        return response.data
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return rejectWithValue(response.data)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const addServiceItem = createAsyncThunk(
  'appServiceItem/addServiceItem',
  async (serviceItem, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.post('/api/app/service-item', serviceItem, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Added Successfully')
        emiter.emit('close-serviceitem-add-or-edit-popup')
        await dispatch(getData(getState().serviceItem.params))
        await dispatch(getById(res.data.id))
        return serviceItem
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateServiceItem = createAsyncThunk(
  'appServiceItem/updateServiceItem',
  async (serviceitem, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.put(`/api/app/service-item/${serviceitem.id}`, serviceitem, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Updated Successfully')
        await dispatch(getData(getState().serviceItem.params))
        await dispatch(getById(serviceitem.id))
        return serviceitem
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteServiceItem = createAsyncThunk(
  'appServiceItem/deleteServiceItem',
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.delete(`/api/app/service-item/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        emiter.emit('close-serviceitem-delete-popup')
        await dispatch(getData(getState().serviceItem.params))
        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const initServiceItem = createAsyncThunk('appServiceItem/initServiceItem', (loading) => loading, {})

export const loadServiceItemtLookups = createAsyncThunk(
  'appServiceItem/loadServiceItemtLookups',
  async () => {
    const caseTypesResponse = await baseurl.get('/api/app/case-type', {
      params: {
        isParant: true,
        MaxResultCount: 1000
      }
    })

    return {
      caseTypes: caseTypesResponse.data?.items
    }
  },
  {}
)

export const appServiceItemSlice = createSlice({
  name: 'appServiceItem',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedServiceItem: null,
    loading: true,
    getByIdLoading: false,
    saveLoading: false
  },
  reducers: {
    setUploads: (state, action) => {
      state.selectedServiceItem = {
        ...state.selectedServiceItem,
        uploads: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.rejected, (state) => {
        state.loading = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.loading = false
      })

      .addCase(getById.pending, (state) => {
        state.getByIdLoading = true
        state.selectedServiceItem = null
      })
      .addCase(getById.rejected, (state) => {
        state.getByIdLoading = false
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.getByIdLoading = false
        state.selectedServiceItem = action.payload
      })

      .addCase(addServiceItem.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(addServiceItem.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(addServiceItem.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(updateServiceItem.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(updateServiceItem.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(updateServiceItem.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(deleteServiceItem.pending, (state) => {
        state.deleteLoading = true
      })
      .addCase(deleteServiceItem.rejected, (state) => {
        state.deleteLoading = false
      })
      .addCase(deleteServiceItem.fulfilled, (state) => {
        state.deleteLoading = false
      })
      .addCase(initServiceItem.fulfilled, (state) => {
        state.selectedServiceItem = null
      })

    builder.addCase(loadServiceItemtLookups.fulfilled, (state, action) => {
      state.caseTypes = action.payload.caseTypes
    })
  }
})
export const { setUploads } = appServiceItemSlice.actions
export default appServiceItemSlice.reducer
